import {httpRequest} from '../config/axios';
import {getDateFromText} from '../utils/helper';

export async function storeOutlet(requestBody) {
  try {
    const response = await httpRequest.post('/outlet', requestBody);
    return response;
  } catch (error) {
    return error;
  }
}

export async function fetchOutlet({pageSize, pageIndex, filters}) {
  const filterQuery = {partnerCode: 'ODPT00002'};
  for (const item of filters) {
    if (item.value && item.value.length > 0) {
      if (item.key === 'channelCode') {
        filterQuery['channelCode'] = [];
        filterQuery['channelGroupCode'] = [];
        const splitValues = item.value.map((ele) => ele.split('-'));
        for (const splitValue of splitValues) {
          filterQuery['channelCode'].push(splitValue[1]);
          filterQuery['channelGroupCode'].push(splitValue[0]);
        }
      } else {
        filterQuery[item.key] = item.value;
      }
    }
  }
  const response = await httpRequest.post('/get-outlet-list', {
    filters: filterQuery,
    page: pageIndex,
    limit: pageSize,
  });
  return {
    rows: response?.data?.data?.data?.list || [],
    totalCount: response?.data?.data?.data?.totalCount || 0,
  };
}

export async function fetchAncillaryData(partnerStoreCode) {
  const response = await httpRequest.get(`/outlet-ancillary/${partnerStoreCode}`);
  return {
    rows: response?.data?.data?.data || [],
  };
}

export async function fetchVirtualStore(storeId) {
  try {
    const response = await httpRequest.get(`/outlet/virtual-store/${storeId}`);
    return response;
  } catch (error) {
    return {status: false, error: error.data?.data?.error?.message || error.message};
  }
}

export async function updateOutlet(data) {
  try {
    const response = await httpRequest.put('/outlet', data);
    return response;
  } catch (error) {
    return error;
  }
}

export async function insertOutletAncillaryData(data) {
  try {
    const response = await httpRequest.post('/outlet-ancillary', data);
    return response;
  } catch (error) {
    return error;
  }
}

export async function updateOutletAncillaryData(data) {
  try {
    const response = await httpRequest.put('/outlet-ancillary', data);
    return response;
  } catch (error) {
    return error;
  }
}

export async function fetchBulkOutletSyncHistory() {
  try {
    const date = getDateFromText('Today');
    const response = await httpRequest.post('get-operation-history', {
      date: {
        from: new Date(new Date(date[0]).setFullYear(new Date(date[0]).getFullYear() - 1)).toISOString(),
        to: date[1],
      },
      filters: {
        operationType: ['BULK_STORE_STATUS_SYNC'],
      },
      page: 1,
      sort: {
        field: 'timestamp',
        type: -1,
      },
      limit: 25,
    });
    return {rows: response?.data?.data?.data};
  } catch (error) {
    return error;
  }
}

export async function bulkOutletSync(body) {
  try {
    const response = await httpRequest.post('/outlets/bulk-sync', body);
    return {success: response?.data?.statusCode === 202, data: response?.data?.data};
  } catch (error) {
    return {success: false, data: error?.data?.data};
  }
}
